import {
  createResetButton,
} from '../builder-definition/filters';
import { createPlainText } from '../builder-definition/filters/page';

export default {
  commonSearch: null,
  id: '',
  spendingGoal: '',
  discountPercent: '',
  isArchived: false,
};

export const config = {
  defaultSearchPropName: 'id',
  exceptionFilters: ['spendingGoal'],
  rows: [
    [
      createPlainText({
        filterProp: 'commonSearch',
        placeholder: 'Search',
      }),
      createResetButton(),
    ],
  ],
};
